import React from "react";
import ReactDOM from "react-dom";

import Lib from "./Lib";
// import nodebuger from "./nodebugger";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <Lib
    useImageHosting={{
      url: "",
      name: "图片上传功能暂不支持",
      isSmmsOpen: false,
      isQiniuyunOpen: false,
      isAliyunOpen: false,
      isGiteeOpen: false,
      isGitHubOpen: false,
    }}
    defaultTitle="五岁 MD 排版编辑器"
  />,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
